export default __webpack_public_path__ + "static/media/superball_web_light.d5f38b9a.png";